import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class DarkKnight extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'darkKnight')
    
    this.maxHealth = 100
    this.health = 100
    this.damage = PLAYER_DAMAGE.STANDARD
    this.moveSpeed = 3.5
    this.attackRange = 1.5
    this.attackCooldown = 1.5
    this.detectionRange = 16
    this.knockbackResistance = 0.7
    
    this.blockChance = 0.4
  }
  
  takeDamage(amount) {
    // Chance to block attack
    if (Math.random() < this.blockChance) {
      // Blocked - reduced damage
      amount *= 0.2
      this.flashTimer = 0.05 // Short flash to show block
    }
    
    super.takeDamage(amount)
  }
  
  dropLoot() {
    if (Math.random() < 0.25) {
      this.game.itemManager.spawnItem({
        type: 'sword',
        id: 'iron_sword',
        name: 'Iron Sword',
        damage: 20,
        count: 1
      }, { x: this.x, y: this.y })
    }
    
    if (Math.random() < 0.2) {
      this.game.itemManager.spawnItem({
        type: 'armor',
        id: 'iron_chestplate',
        name: 'Iron Chestplate',
        defense: 5,
        count: 1
      }, { x: this.x, y: this.y })
    }
    
    if (Math.random() < 0.6) {
      this.game.itemManager.spawnItem({
        type: 'block',
        id: 'planks',
        name: 'Wood Planks',
        blockType: 9,
        count: 4 + Math.floor(Math.random() * 5)
      }, { x: this.x, y: this.y })
    }
  }
}
